import { KlaviyoEventType } from "@redotech/redo-model/klaviyo-integration";
import * as z from "zod/v4";

export const updateKlaviyoIntegration = {
  name: "updateKlaviyoIntegration" as const,
  input: z.object({ events: z.array(z.enum(KlaviyoEventType)).optional() }),
  output: z.object({}),
};

export type UpdateKlaviyoIntegrationInput = z.infer<
  typeof updateKlaviyoIntegration.input
>;

export const setKlaviyoIntegration = {
  name: "setKlaviyoIntegration" as const,
  input: z.object({
    privateApiKey: z.string().min(1, "API key is required"),
    events: z.array(z.enum(KlaviyoEventType)).optional(),
  }),
  output: z.object({}),
};

export type SetKlaviyoIntegrationInput = z.infer<
  typeof setKlaviyoIntegration.input
>;

export const getKlaviyoIntegration = {
  name: "getKlaviyoIntegration" as const,
  input: z.object({}),
  output: z.object({
    klaviyoIntegration: z.optional(
      z.object({ events: z.array(z.enum(KlaviyoEventType)) }),
    ),
  }),
};

export type GetKlaviyoIntegrationOutput = z.infer<
  typeof getKlaviyoIntegration.output
>;

export const disconnectKlaviyoIntegration = {
  name: "disconnectKlaviyoIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
